import lodash from "lodash";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { bailiffDialogMergedRawSelector } from "store/bailiff/bailiff/dialog/bailiff_dialog.selector";
import { draftDialogEditedSelector } from "store/bailiff/draft/dialog/draft_dialog.selector";

//refine
export const useActionDraftMergeRefine = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const merge = useSelector(bailiffDialogMergedRawSelector);
  const edited = useSelector(draftDialogEditedSelector);
  // -------------------------- FUNCTION ------------------------
  const compareFrom = (a, b) => {
    const aHasFix = a?.fix !== undefined && a?.fix !== "";
    const bHasFix = b?.fix !== undefined && b?.fix !== "";
    const aHasFixFrom = a?.fixFrom !== undefined && a?.fixFrom !== "";
    const bHasFixFrom = b?.fixFrom !== undefined && b?.fixFrom !== "";
    const isAUpdated = a?.update || (aHasFix && aHasFixFrom);
    const isBUpdated = b?.update || (bHasFix && bHasFixFrom);
    const fromA = isAUpdated ? a.fixFrom : a.from;
    const fromB = isBUpdated ? b.fixFrom : b.from;
    // console.log({ a, isAUpdated });
    return fromA - fromB;
  };

  const sorted = useMemo(() => {
    const combine = refineData({ merge, edited });
    const sorted = combine.sort(compareFrom);

    return sorted;
  }, [merge, edited]);
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { data: sorted };
};

const refineData = ({ merge, edited }) => {
  const dataMerge = lodash.cloneDeep(merge) || [];
  const dataEdited = lodash.cloneDeep(edited) || [];

  dataEdited?.forEach((edited) => {
    const add = edited?.add;
    const update = edited?.update;
    const remove = edited?.remove;

    const index = dataMerge?.findIndex((d) => {
      const valid = d?.segId === edited?.repId;

      return valid;
    });

    if (remove && index >= 0) {
      // xoá.
      dataMerge.splice(index, 1);
    }

    if (!remove && add) {
      dataMerge.push(edited);
    }

    if (!remove && !add && update && index >= 0) {
      dataMerge[index] = {
        ...dataMerge[index],
        text: edited?.text,
        from: edited?.from,
        to: edited?.to,
        fix: edited?.fix || "",
        fixFrom: edited?.fixFrom,
        fixTo: edited?.fixTo,
        fixSpeaker: edited?.fixSpeaker,
        docId: edited?.docId,
      };
    }
  });

  return dataMerge;
};
